import {TableChart} from '@mui/icons-material';
import WithEtsyAccount from '../../../pages/etsy/WithEtsyAccount';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import {HelpTutorialEnum} from '../../../variables/helpTutorial';
import EtsyBulkUpdateGoogleSheet from './EtsyBulkUpdateGoogleSheet';

export const etsyBulkUpdateGoogleSheet: FeatureObject = {
  type: 'feature',
  title: 'Bulk Update Listings with Google Sheet',
  description:
    'Link an Etsy store and a Google Sheet. Export listings to the sheet or update Etsy from the sheet (listingId, title, tags, description, favourite, view, last update).',
  IconComponent: TableChart,
  showFeatureFrontPage: true,
  path: '/etsyBulkUpdateGoogleSheet',
  component: (user) => (
    <WithEtsyAccount
      featureName="Bulk Update Listings with Google Sheet"
      helpTutorialEnum={HelpTutorialEnum.ETSY_BULK_UPDATE_GOOGLE_SHEET}
      component={(selectedAccount) =>
        selectedAccount ? <EtsyBulkUpdateGoogleSheet selectedAccount={selectedAccount} user={user} /> : null
      }
    />
  ),
  status: FeatureStatus.PROD,
  tags: ['etsy', 'bulk', 'update', 'listings', 'google sheet'],
};
